import React from 'react';
import { Send, MapPin } from 'lucide-react';
import { Container, InputWrapper, IconButton, Input, SendButton, Disclaimer } from './styles';

interface ChatInputProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  isLoading: boolean;
  handleSendMessage: () => void;
  handleLocationShare: () => void;
  handleKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  inputValue,
  setInputValue,
  isLoading,
  handleSendMessage,
  handleLocationShare,
  handleKeyPress,
}) => {

  return (
    <Container>
      <InputWrapper>
        <Input
          type="text"
          placeholder="Ask anything..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
        />
        <IconButton onClick={handleLocationShare} disabled={isLoading}>
          <MapPin size={20} />
        </IconButton>
        <SendButton
          onClick={() => {
            handleSendMessage()
          }}
          disabled={isLoading || !inputValue.trim()}
        >
          <Send size={20} />
        </SendButton>
      </InputWrapper>
      <Disclaimer>
        Nearvana Chat AI can make mistakes. Check important info.
      </Disclaimer>
    </Container>
  );
};

export default ChatInput;

